import * as supabaseHandlers from './supabase/handlers';
import { 
  fetchUsers, 
  fetchPosts, 
  fetchPostById, 
  createPost, 
  toggleLike, 
  addComment, 
  getComments, 
  getUserProfile,
  toggleFollow,
  toggleFavorite,
  fetchFavoritePosts,
  addToFavorites,
  removeFromFavorites,
  getFavorites,
  incrementViewCount,
  createNotification,
  getNotifications,
  markNotificationRead,
  markAllNotificationsRead,
  searchPosts,
  updateUserProfile
} from './supabase/handlers';

// Collect all handlers into a single object
const mcp = {
  ...supabaseHandlers,
  // Add other MCP modules here if needed
};

/**
 * Initialize MCP for Cursor AI
 */
export const initMCP = () => {
  console.log('Initializing MCP for Cursor AI...');
  
  // Register all MCP handlers
  window.mcp = {
    fetchUsers,
    fetchPosts,
    fetchPostById,
    createPost,
    toggleLike,
    addComment,
    getComments,
    getUserProfile,
    toggleFollow,
    toggleFavorite,
    fetchFavoritePosts,
    addToFavorites,
    removeFromFavorites,
    getFavorites,
    incrementViewCount,
    createNotification,
    getNotifications,
    markNotificationRead,
    markAllNotificationsRead,
    searchPosts,
    updateUserProfile
  };
  
  console.log('MCP initialized successfully!');
};

export default mcp; 